module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('avatar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), (_vm.editing && _vm.user.profile.avatar) ? _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.delAvatar
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('image-uploader', {
    attrs: {
      "maxWidth": 128,
      "maxHeight": 128,
      "quality": 0.9,
      "preview": true,
      "className": ['form-input']
    },
    on: {
      "input": _vm.setPic
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.brand),
      expression: "user.profile.brand"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.brands), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(v))])
  }), 0)]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.getBrand()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.firstname),
      expression: "user.profile.firstname"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "firstname", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.firstname))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.lastname),
      expression: "user.profile.lastname"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "lastname", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.lastname))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_d),
      expression: "dob_d"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "DD"
    },
    domProps: {
      "value": (_vm.dob_d)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_d = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_m),
      expression: "dob_m"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.dob_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_m = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob_y),
      expression: "dob_y"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "YYYY"
    },
    domProps: {
      "value": (_vm.dob_y)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob_y = $event.target.value
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.dob))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.email))])])])]), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.phone),
      expression: "user.profile.phone"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.user.profile.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "phone", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.phone))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.business),
      expression: "user.profile.business"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.business)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "business", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.business))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.corporate),
      expression: "user.profile.corporate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.profile.corporate) ? _vm._i(_vm.user.profile.corporate, null) > -1 : (_vm.user.profile.corporate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.profile.corporate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user.profile, "corporate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user.profile, "corporate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user.profile, "corporate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.corporate ? 'Yes' : 'No'))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.address1),
      expression: "user.profile.address1"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "address1", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.address1))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.address2),
      expression: "user.profile.address2"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "address2", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.address2))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.suburb),
      expression: "user.profile.suburb"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "suburb", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.suburb))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.postcode),
      expression: "user.profile.postcode"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "postcode", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.postcode))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [(_vm.user.profile.country === 'AUSTRALIA') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.state),
      expression: "user.profile.state"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")])]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.state),
      expression: "user.profile.state"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "state", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.state))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.passport),
      expression: "user.profile.passport"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "passport", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.passport))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.country),
      expression: "user.profile.country"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.countries), function(v, k) {
    return _c('option', {
      domProps: {
        "value": k
      }
    }, [_vm._v(_vm._s(k))])
  })], 2)]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.country))])])])]) : _vm._e(), _vm._v(" "), (_vm.isEdAdmin && _vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [(_vm.user.agreement) ? _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.unlinkAgreement
    }
  }, [_vm._v("Unlink")])]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAgreement),
      expression: "newAgreement"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAgreement = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.agreements), function(a) {
    return _c('option', {
      domProps: {
        "value": a._id
      }
    }, [_vm._v(_vm._s(a.name) + " (" + _vm._s(a.email) + ")")])
  }), 0)]) : _c('div', [(_vm.user.agreement) ? _c('router-link', {
    attrs: {
      "to": '/agreements/' + _vm.user.agreement
    }
  }, [_vm._v("View")]) : _c('label', {
    staticClass: "form-label"
  }, [_vm._v("N/A")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.source),
      expression: "user.profile.source"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.profile, "source", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sources), function(s) {
    return _c('option', {
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s))])
  })], 2)]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.source))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserClient) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile.details),
      expression: "user.profile.details"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.profile.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.profile, "details", $event.target.value)
      }
    }
  })]) : _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.user.profile.details))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.successMsg) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), (_vm.showButtons) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.isEdAdmin) ? _c('div', {
    staticClass: "col-12 adminControls"
  }, [(!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editMode($event)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.wait1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (!_vm.user.verified && !_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.wait2
    },
    on: {
      "click": _vm.invite
    }
  }, [_vm._v("\n          Invite\n        ")]) : _vm._e(), _vm._v(" "), (_vm.user.level === 6) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toLevel(5)
      }
    }
  }, [_vm._v("Make full client")]) : _vm._e(), _vm._v(" "), (_vm.user.level === 5) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toLevel(6)
      }
    }
  }, [_vm._v("Make prospect")]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.archiveUser($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.archived ? 'Unarchive' : 'Archive') + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showDelModal = true
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()]) : _c('div', {
    staticClass: "col-12"
  }, [(!_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editMode($event)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.wait1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showDelModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.delUser
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showDelModal = false
      }
    }
  }, [_vm._v("No")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("New avatar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Brand")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("First name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Last name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Date of birth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Phone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Business")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Corporate client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Address line 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Address line 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Suburb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Postcode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Passport number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Country")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Cost agreement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client source")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("More details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n          Are you sure?\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9758fa0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/userProfile.vue
// module id = 526
// module chunks = 1